export const countryCode = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    flag: '🇦🇫',
    label: '🇦🇫 Afghanistan (+93)'
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL',
    flag: '🇦🇱',
    label: '🇦🇱 Albania (+355)'
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
    flag: '🇩🇿',
    label: '🇩🇿 Algeria (+213)'
  },
  {
    name: 'American Samoa',
    dial_code: '+1',
    code: 'AS',
    flag: '🇦🇸',
    label: '🇦🇸 American Samoa (+1)'
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD',
    flag: '🇦🇩',
    label: '🇦🇩 Andorra (+376)'
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO',
    flag: '🇦🇴',
    label: '🇦🇴 Angola (+244)'
  },
  {
    name: 'Anguilla',
    dial_code: '+1',
    code: 'AI',
    flag: '🇦🇮',
    label: '🇦🇮 Anguilla (+1)'
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1',
    code: 'AG',
    flag: '🇦🇬',
    label: '🇦🇬 Antigua and Barbuda (+1)'
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR',
    flag: '🇦🇷',
    label: '🇦🇷 Argentina (+54)'
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM',
    flag: '🇦🇲',
    label: '🇦🇲 Armenia (+374)'
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: 'AW',
    flag: '🇦🇼',
    label: '🇦🇼 Aruba (+297)'
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU',
    flag: '🇦🇺',
    label: '🇦🇺 Australia (+61)'
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT',
    flag: '🇦🇹',
    label: '🇦🇹 Austria (+43)'
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
    flag: '🇦🇿',
    label: '🇦🇿 Azerbaijan (+994)'
  },
  {
    name: 'Bahamas',
    dial_code: '+1',
    code: 'BS',
    flag: '🇧🇸',
    label: '🇧🇸 Bahamas (+1)'
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
    flag: '🇧🇭',
    label: '🇧🇭 Bahrain (+973)'
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
    flag: '🇧🇩',
    label: '🇧🇩 Bangladesh (+880)'
  },
  {
    name: 'Barbados',
    dial_code: '+1',
    code: 'BB',
    flag: '🇧🇧',
    label: '🇧🇧 Barbados (+1)'
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY',
    flag: '🇧🇾',
    label: '🇧🇾 Belarus (+375)'
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE',
    flag: '🇧🇪',
    label: '🇧🇪 Belgium (+32)'
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ',
    flag: '🇧🇿',
    label: '🇧🇿 Belize (+501)'
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ',
    flag: '🇧🇯',
    label: '🇧🇯 Benin (+229)'
  },
  {
    name: 'Bermuda',
    dial_code: '+1',
    code: 'BM',
    flag: '🇧🇲',
    label: '🇧🇲 Bermuda (+1)'
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
    flag: '🇧🇹',
    label: '🇧🇹 Bhutan (+975)'
  },
  {
    name: 'Bolivia, Plurinational State of',
    dial_code: '+591',
    code: 'BO',
    flag: '🇧🇴',
    label: '🇧🇴 Bolivia, Plurinational State of (+591)'
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    dial_code: '+599',
    code: 'BQ',
    flag: '🇧🇶',
    label: '🇧🇶 Bonaire, Sint Eustatius and Saba (+599)'
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
    flag: '🇧🇦',
    label: '🇧🇦 Bosnia and Herzegovina (+387)'
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW',
    flag: '🇧🇼',
    label: '🇧🇼 Botswana (+267)'
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR',
    flag: '🇧🇷',
    label: '🇧🇷 Brazil (+55)'
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO',
    flag: '🇮🇴',
    label: '🇮🇴 British Indian Ocean Territory (+246)'
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
    flag: '🇧🇳',
    label: '🇧🇳 Brunei Darussalam (+673)'
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
    flag: '🇧🇬',
    label: '🇧🇬 Bulgaria (+359)'
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
    flag: '🇧🇫',
    label: '🇧🇫 Burkina Faso (+226)'
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI',
    flag: '🇧🇮',
    label: '🇧🇮 Burundi (+257)'
  },
  {
    name: 'Cabo Verde',
    dial_code: '+238',
    code: 'CV',
    flag: '🇨🇻',
    label: '🇨🇻 Cabo Verde (+238)'
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
    flag: '🇰🇭',
    label: '🇰🇭 Cambodia (+855)'
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
    flag: '🇨🇲',
    label: '🇨🇲 Cameroon (+237)'
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA',
    flag: '🇨🇦',
    label: '🇨🇦 Canada (+1)'
  },
  {
    name: 'Cayman Islands',
    dial_code: '+1',
    code: 'KY',
    flag: '🇰🇾',
    label: '🇰🇾 Cayman Islands (+1)'
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
    flag: '🇨🇫',
    label: '🇨🇫 Central African Republic (+236)'
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: 'TD',
    flag: '🇹🇩',
    label: '🇹🇩 Chad (+235)'
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL',
    flag: '🇨🇱',
    label: '🇨🇱 Chile (+56)'
  },
  {
    name: 'China',
    dial_code: '+86',
    code: 'CN',
    flag: '🇨🇳',
    label: '🇨🇳 China (+86)'
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
    flag: '🇨🇽',
    label: '🇨🇽 Christmas Island (+61)'
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC',
    flag: '🇨🇨',
    label: '🇨🇨 Cocos (Keeling) Islands (+61)'
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO',
    flag: '🇨🇴',
    label: '🇨🇴 Colombia (+57)'
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM',
    flag: '🇰🇲',
    label: '🇰🇲 Comoros (+269)'
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG',
    flag: '🇨🇬',
    label: '🇨🇬 Congo (+242)'
  },
  {
    name: 'Congo, The Democratic Republic of the',
    dial_code: '+243',
    code: 'CD',
    flag: '🇨🇩',
    label: '🇨🇩 Congo, The Democratic Republic of the (+243)'
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
    flag: '🇨🇰',
    label: '🇨🇰 Cook Islands (+682)'
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
    flag: '🇨🇷',
    label: '🇨🇷 Costa Rica (+506)'
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR',
    flag: '🇭🇷',
    label: '🇭🇷 Croatia (+385)'
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU',
    flag: '🇨🇺',
    label: '🇨🇺 Cuba (+53)'
  },
  {
    name: 'Curaçao',
    dial_code: '+599',
    code: 'CW',
    flag: '🇨🇼',
    label: '🇨🇼 Curaçao (+599)'
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
    flag: '🇨🇾',
    label: '🇨🇾 Cyprus (+357)'
  },
  {
    name: 'Czechia',
    dial_code: '+420',
    code: 'CZ',
    flag: '🇨🇿',
    label: '🇨🇿 Czechia (+420)'
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK',
    flag: '🇩🇰',
    label: '🇩🇰 Denmark (+45)'
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
    flag: '🇩🇯',
    label: '🇩🇯 Djibouti (+253)'
  },
  {
    name: 'Dominica',
    dial_code: '+1',
    code: 'DM',
    flag: '🇩🇲',
    label: '🇩🇲 Dominica (+1)'
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1',
    code: 'DO',
    flag: '🇩🇴',
    label: '🇩🇴 Dominican Republic (+1)'
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
    flag: '🇪🇨',
    label: '🇪🇨 Ecuador (+593)'
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG',
    flag: '🇪🇬',
    label: '🇪🇬 Egypt (+20)'
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
    flag: '🇸🇻',
    label: '🇸🇻 El Salvador (+503)'
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
    flag: '🇬🇶',
    label: '🇬🇶 Equatorial Guinea (+240)'
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
    flag: '🇪🇷',
    label: '🇪🇷 Eritrea (+291)'
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE',
    flag: '🇪🇪',
    label: '🇪🇪 Estonia (+372)'
  },
  {
    name: 'Eswatini',
    dial_code: '+268',
    code: 'SZ',
    flag: '🇸🇿',
    label: '🇸🇿 Eswatini (+268)'
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
    flag: '🇪🇹',
    label: '🇪🇹 Ethiopia (+251)'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: 'FK',
    flag: '🇫🇰',
    label: '🇫🇰 Falkland Islands (Malvinas) (+500)'
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
    flag: '🇫🇴',
    label: '🇫🇴 Faroe Islands (+298)'
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
    flag: '🇫🇯',
    label: '🇫🇯 Fiji (+679)'
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI',
    flag: '🇫🇮',
    label: '🇫🇮 Finland (+358)'
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR',
    flag: '🇫🇷',
    label: '🇫🇷 France (+33)'
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
    flag: '🇬🇫',
    label: '🇬🇫 French Guiana (+594)'
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
    flag: '🇵🇫',
    label: '🇵🇫 French Polynesia (+689)'
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA',
    flag: '🇬🇦',
    label: '🇬🇦 Gabon (+241)'
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM',
    flag: '🇬🇲',
    label: '🇬🇲 Gambia (+220)'
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE',
    flag: '🇬🇪',
    label: '🇬🇪 Georgia (+995)'
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE',
    flag: '🇩🇪',
    label: '🇩🇪 Germany (+49)'
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: 'GH',
    flag: '🇬🇭',
    label: '🇬🇭 Ghana (+233)'
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
    flag: '🇬🇮',
    label: '🇬🇮 Gibraltar (+350)'
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: 'GR',
    flag: '🇬🇷',
    label: '🇬🇷 Greece (+30)'
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL',
    flag: '🇬🇱',
    label: '🇬🇱 Greenland (+299)'
  },
  {
    name: 'Grenada',
    dial_code: '+1',
    code: 'GD',
    flag: '🇬🇩',
    label: '🇬🇩 Grenada (+1)'
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
    flag: '🇬🇵',
    label: '🇬🇵 Guadeloupe (+590)'
  },
  {
    name: 'Guam',
    dial_code: '+1',
    code: 'GU',
    flag: '🇬🇺',
    label: '🇬🇺 Guam (+1)'
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
    flag: '🇬🇹',
    label: '🇬🇹 Guatemala (+502)'
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    code: 'GG',
    flag: '🇬🇬',
    label: '🇬🇬 Guernsey (+44)'
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN',
    flag: '🇬🇳',
    label: '🇬🇳 Guinea (+224)'
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
    flag: '🇬🇼',
    label: '🇬🇼 Guinea-Bissau (+245)'
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    code: 'GY',
    flag: '🇬🇾',
    label: '🇬🇾 Guyana (+592)'
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT',
    flag: '🇭🇹',
    label: '🇭🇹 Haiti (+509)'
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+39',
    code: 'VA',
    flag: '🇻🇦',
    label: '🇻🇦 Holy See (Vatican City State) (+39)'
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN',
    flag: '🇭🇳',
    label: '🇭🇳 Honduras (+504)'
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
    flag: '🇭🇰',
    label: '🇭🇰 Hong Kong (+852)'
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU',
    flag: '🇭🇺',
    label: '🇭🇺 Hungary (+36)'
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS',
    flag: '🇮🇸',
    label: '🇮🇸 Iceland (+354)'
  },
  {
    name: 'India',
    dial_code: '+91',
    code: 'IN',
    flag: '🇮🇳',
    label: '🇮🇳 India (+91)'
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
    flag: '🇮🇩',
    label: '🇮🇩 Indonesia (+62)'
  },
  {
    name: 'Iran, Islamic Republic of',
    dial_code: '+98',
    code: 'IR',
    flag: '🇮🇷',
    label: '🇮🇷 Iran, Islamic Republic of (+98)'
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: 'IQ',
    flag: '🇮🇶',
    label: '🇮🇶 Iraq (+964)'
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
    flag: '🇮🇪',
    label: '🇮🇪 Ireland (+353)'
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: 'IM',
    flag: '🇮🇲',
    label: '🇮🇲 Isle of Man (+44)'
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT',
    flag: '🇮🇹',
    label: '🇮🇹 Italy (+39)'
  },
  {
    name: 'Jamaica',
    dial_code: '+1',
    code: 'JM',
    flag: '🇯🇲',
    label: '🇯🇲 Jamaica (+1)'
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: 'JP',
    flag: '🇯🇵',
    label: '🇯🇵 Japan (+81)'
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: 'JE',
    flag: '🇯🇪',
    label: '🇯🇪 Jersey (+44)'
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO',
    flag: '🇯🇴',
    label: '🇯🇴 Jordan (+962)'
  },
  {
    name: 'Kazakhstan',
    dial_code: '+7',
    code: 'KZ',
    flag: '🇰🇿',
    label: '🇰🇿 Kazakhstan (+7)'
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: 'KE',
    flag: '🇰🇪',
    label: '🇰🇪 Kenya (+254)'
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
    flag: '🇰🇮',
    label: '🇰🇮 Kiribati (+686)'
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: '+850',
    code: 'KP',
    flag: '🇰🇵',
    label: "🇰🇵 Korea, Democratic People's Republic of (+850)"
  },
  {
    name: 'Korea, Republic of',
    dial_code: '+82',
    code: 'KR',
    flag: '🇰🇷',
    label: '🇰🇷 Korea, Republic of (+82)'
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
    flag: '🇰🇼',
    label: '🇰🇼 Kuwait (+965)'
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
    flag: '🇰🇬',
    label: '🇰🇬 Kyrgyzstan (+996)'
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: '+856',
    code: 'LA',
    flag: '🇱🇦',
    label: "🇱🇦 Lao People's Democratic Republic (+856)"
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV',
    flag: '🇱🇻',
    label: '🇱🇻 Latvia (+371)'
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
    flag: '🇱🇧',
    label: '🇱🇧 Lebanon (+961)'
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
    flag: '🇱🇸',
    label: '🇱🇸 Lesotho (+266)'
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR',
    flag: '🇱🇷',
    label: '🇱🇷 Liberia (+231)'
  },
  {
    name: 'Libya',
    dial_code: '+218',
    code: 'LY',
    flag: '🇱🇾',
    label: '🇱🇾 Libya (+218)'
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
    flag: '🇱🇮',
    label: '🇱🇮 Liechtenstein (+423)'
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
    flag: '🇱🇹',
    label: '🇱🇹 Lithuania (+370)'
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
    flag: '🇱🇺',
    label: '🇱🇺 Luxembourg (+352)'
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: 'MO',
    flag: '🇲🇴',
    label: '🇲🇴 Macao (+853)'
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
    flag: '🇲🇬',
    label: '🇲🇬 Madagascar (+261)'
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW',
    flag: '🇲🇼',
    label: '🇲🇼 Malawi (+265)'
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
    flag: '🇲🇾',
    label: '🇲🇾 Malaysia (+60)'
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV',
    flag: '🇲🇻',
    label: '🇲🇻 Maldives (+960)'
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: 'ML',
    flag: '🇲🇱',
    label: '🇲🇱 Mali (+223)'
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT',
    flag: '🇲🇹',
    label: '🇲🇹 Malta (+356)'
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
    flag: '🇲🇭',
    label: '🇲🇭 Marshall Islands (+692)'
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
    flag: '🇲🇶',
    label: '🇲🇶 Martinique (+596)'
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
    flag: '🇲🇷',
    label: '🇲🇷 Mauritania (+222)'
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
    flag: '🇲🇺',
    label: '🇲🇺 Mauritius (+230)'
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
    flag: '🇾🇹',
    label: '🇾🇹 Mayotte (+262)'
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX',
    flag: '🇲🇽',
    label: '🇲🇽 Mexico (+52)'
  },
  {
    name: 'Micronesia, Federated States of',
    dial_code: '+691',
    code: 'FM',
    flag: '🇫🇲',
    label: '🇫🇲 Micronesia, Federated States of (+691)'
  },
  {
    name: 'Moldova, Republic of',
    dial_code: '+373',
    code: 'MD',
    flag: '🇲🇩',
    label: '🇲🇩 Moldova, Republic of (+373)'
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC',
    flag: '🇲🇨',
    label: '🇲🇨 Monaco (+377)'
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
    flag: '🇲🇳',
    label: '🇲🇳 Mongolia (+976)'
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
    flag: '🇲🇪',
    label: '🇲🇪 Montenegro (+382)'
  },
  {
    name: 'Montserrat',
    dial_code: '+1',
    code: 'MS',
    flag: '🇲🇸',
    label: '🇲🇸 Montserrat (+1)'
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA',
    flag: '🇲🇦',
    label: '🇲🇦 Morocco (+212)'
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
    flag: '🇲🇿',
    label: '🇲🇿 Mozambique (+258)'
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
    flag: '🇲🇲',
    label: '🇲🇲 Myanmar (+95)'
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA',
    flag: '🇳🇦',
    label: '🇳🇦 Namibia (+264)'
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR',
    flag: '🇳🇷',
    label: '🇳🇷 Nauru (+674)'
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP',
    flag: '🇳🇵',
    label: '🇳🇵 Nepal (+977)'
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
    flag: '🇳🇱',
    label: '🇳🇱 Netherlands (+31)'
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
    flag: '🇳🇨',
    label: '🇳🇨 New Caledonia (+687)'
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
    flag: '🇳🇿',
    label: '🇳🇿 New Zealand (+64)'
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
    flag: '🇳🇮',
    label: '🇳🇮 Nicaragua (+505)'
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: 'NE',
    flag: '🇳🇪',
    label: '🇳🇪 Niger (+227)'
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
    flag: '🇳🇬',
    label: '🇳🇬 Nigeria (+234)'
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU',
    flag: '🇳🇺',
    label: '🇳🇺 Niue (+683)'
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
    flag: '🇳🇫',
    label: '🇳🇫 Norfolk Island (+672)'
  },
  {
    name: 'North Macedonia',
    dial_code: '+389',
    code: 'MK',
    flag: '🇲🇰',
    label: '🇲🇰 North Macedonia (+389)'
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1',
    code: 'MP',
    flag: '🇲🇵',
    label: '🇲🇵 Northern Mariana Islands (+1)'
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: 'NO',
    flag: '🇳🇴',
    label: '🇳🇴 Norway (+47)'
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM',
    flag: '🇴🇲',
    label: '🇴🇲 Oman (+968)'
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
    flag: '🇵🇰',
    label: '🇵🇰 Pakistan (+92)'
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW',
    flag: '🇵🇼',
    label: '🇵🇼 Palau (+680)'
  },
  {
    name: 'Palestine, State of',
    dial_code: '+970',
    code: 'PS',
    flag: '🇵🇸',
    label: '🇵🇸 Palestine, State of (+970)'
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA',
    flag: '🇵🇦',
    label: '🇵🇦 Panama (+507)'
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
    flag: '🇵🇬',
    label: '🇵🇬 Papua New Guinea (+675)'
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
    flag: '🇵🇾',
    label: '🇵🇾 Paraguay (+595)'
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE',
    flag: '🇵🇪',
    label: '🇵🇪 Peru (+51)'
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH',
    flag: '🇵🇭',
    label: '🇵🇭 Philippines (+63)'
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: 'PL',
    flag: '🇵🇱',
    label: '🇵🇱 Poland (+48)'
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT',
    flag: '🇵🇹',
    label: '🇵🇹 Portugal (+351)'
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1',
    code: 'PR',
    flag: '🇵🇷',
    label: '🇵🇷 Puerto Rico (+1)'
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA',
    flag: '🇶🇦',
    label: '🇶🇦 Qatar (+974)'
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO',
    flag: '🇷🇴',
    label: '🇷🇴 Romania (+40)'
  },
  {
    name: 'Russian Federation',
    dial_code: '+7',
    code: 'RU',
    flag: '🇷🇺',
    label: '🇷🇺 Russian Federation (+7)'
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
    flag: '🇷🇼',
    label: '🇷🇼 Rwanda (+250)'
  },
  {
    name: 'Réunion',
    dial_code: '+262',
    code: 'RE',
    flag: '🇷🇪',
    label: '🇷🇪 Réunion (+262)'
  },
  {
    name: 'Saint Barthélemy',
    dial_code: '+590',
    code: 'BL',
    flag: '🇧🇱',
    label: '🇧🇱 Saint Barthélemy (+590)'
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    dial_code: '+290',
    code: 'SH',
    flag: '🇸🇭',
    label: '🇸🇭 Saint Helena, Ascension and Tristan da Cunha (+290)'
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1',
    code: 'KN',
    flag: '🇰🇳',
    label: '🇰🇳 Saint Kitts and Nevis (+1)'
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1',
    code: 'LC',
    flag: '🇱🇨',
    label: '🇱🇨 Saint Lucia (+1)'
  },
  {
    name: 'Saint Martin (French part)',
    dial_code: '+590',
    code: 'MF',
    flag: '🇲🇫',
    label: '🇲🇫 Saint Martin (French part) (+590)'
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM',
    flag: '🇵🇲',
    label: '🇵🇲 Saint Pierre and Miquelon (+508)'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1',
    code: 'VC',
    flag: '🇻🇨',
    label: '🇻🇨 Saint Vincent and the Grenadines (+1)'
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS',
    flag: '🇼🇸',
    label: '🇼🇸 Samoa (+685)'
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM',
    flag: '🇸🇲',
    label: '🇸🇲 San Marino (+378)'
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
    flag: '🇸🇹',
    label: '🇸🇹 Sao Tome and Principe (+239)'
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
    flag: '🇸🇦',
    label: '🇸🇦 Saudi Arabia (+966)'
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN',
    flag: '🇸🇳',
    label: '🇸🇳 Senegal (+221)'
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS',
    flag: '🇷🇸',
    label: '🇷🇸 Serbia (+381)'
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
    flag: '🇸🇨',
    label: '🇸🇨 Seychelles (+248)'
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
    flag: '🇸🇱',
    label: '🇸🇱 Sierra Leone (+232)'
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG',
    flag: '🇸🇬',
    label: '🇸🇬 Singapore (+65)'
  },
  {
    name: 'Sint Maarten (Dutch part)',
    dial_code: '+1',
    code: 'SX',
    flag: '🇸🇽',
    label: '🇸🇽 Sint Maarten (Dutch part) (+1)'
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
    flag: '🇸🇰',
    label: '🇸🇰 Slovakia (+421)'
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
    flag: '🇸🇮',
    label: '🇸🇮 Slovenia (+386)'
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
    flag: '🇸🇧',
    label: '🇸🇧 Solomon Islands (+677)'
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO',
    flag: '🇸🇴',
    label: '🇸🇴 Somalia (+252)'
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
    flag: '🇿🇦',
    label: '🇿🇦 South Africa (+27)'
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: 'SS',
    flag: '🇸🇸',
    label: '🇸🇸 South Sudan (+211)'
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: 'ES',
    flag: '🇪🇸',
    label: '🇪🇸 Spain (+34)'
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
    flag: '🇱🇰',
    label: '🇱🇰 Sri Lanka (+94)'
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: 'SD',
    flag: '🇸🇩',
    label: '🇸🇩 Sudan (+249)'
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR',
    flag: '🇸🇷',
    label: '🇸🇷 Suriname (+597)'
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
    flag: '🇸🇯',
    label: '🇸🇯 Svalbard and Jan Mayen (+47)'
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE',
    flag: '🇸🇪',
    label: '🇸🇪 Sweden (+46)'
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
    flag: '🇨🇭',
    label: '🇨🇭 Switzerland (+41)'
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    code: 'SY',
    flag: '🇸🇾',
    label: '🇸🇾 Syrian Arab Republic (+963)'
  },
  {
    name: 'Taiwan, Province of China',
    dial_code: '+886',
    code: 'TW',
    flag: '🇹🇼',
    label: '🇹🇼 Taiwan, Province of China (+886)'
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
    flag: '🇹🇯',
    label: '🇹🇯 Tajikistan (+992)'
  },
  {
    name: 'Tanzania, United Republic of',
    dial_code: '+255',
    code: 'TZ',
    flag: '🇹🇿',
    label: '🇹🇿 Tanzania, United Republic of (+255)'
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH',
    flag: '🇹🇭',
    label: '🇹🇭 Thailand (+66)'
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
    flag: '🇹🇱',
    label: '🇹🇱 Timor-Leste (+670)'
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG',
    flag: '🇹🇬',
    label: '🇹🇬 Togo (+228)'
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
    flag: '🇹🇰',
    label: '🇹🇰 Tokelau (+690)'
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO',
    flag: '🇹🇴',
    label: '🇹🇴 Tonga (+676)'
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1',
    code: 'TT',
    flag: '🇹🇹',
    label: '🇹🇹 Trinidad and Tobago (+1)'
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
    flag: '🇹🇳',
    label: '🇹🇳 Tunisia (+216)'
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
    flag: '🇹🇲',
    label: '🇹🇲 Turkmenistan (+993)'
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1',
    code: 'TC',
    flag: '🇹🇨',
    label: '🇹🇨 Turks and Caicos Islands (+1)'
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
    flag: '🇹🇻',
    label: '🇹🇻 Tuvalu (+688)'
  },
  {
    name: 'Türkiye',
    dial_code: '+90',
    code: 'TR',
    flag: '🇹🇷',
    label: '🇹🇷 Türkiye (+90)'
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG',
    flag: '🇺🇬',
    label: '🇺🇬 Uganda (+256)'
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
    flag: '🇺🇦',
    label: '🇺🇦 Ukraine (+380)'
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
    flag: '🇦🇪',
    label: '🇦🇪 United Arab Emirates (+971)'
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
    flag: '🇬🇧',
    label: '🇬🇧 United Kingdom (+44)'
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US',
    flag: '🇺🇸',
    label: '🇺🇸 United States (+1)'
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
    flag: '🇺🇾',
    label: '🇺🇾 Uruguay (+598)'
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
    flag: '🇺🇿',
    label: '🇺🇿 Uzbekistan (+998)'
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
    flag: '🇻🇺',
    label: '🇻🇺 Vanuatu (+678)'
  },
  {
    name: 'Venezuela, Bolivarian Republic of',
    dial_code: '+58',
    code: 'VE',
    flag: '🇻🇪',
    label: '🇻🇪 Venezuela, Bolivarian Republic of (+58)'
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: 'VN',
    flag: '🇻🇳',
    label: '🇻🇳 Vietnam (+84)'
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1',
    code: 'VG',
    flag: '🇻🇬',
    label: '🇻🇬 Virgin Islands, British (+1)'
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1',
    code: 'VI',
    flag: '🇻🇮',
    label: '🇻🇮 Virgin Islands, U.S. (+1)'
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
    flag: '🇼🇫',
    label: '🇼🇫 Wallis and Futuna (+681)'
  },
  {
    name: 'Western Sahara',
    dial_code: '+212',
    code: 'EH',
    flag: '🇪🇭',
    label: '🇪🇭 Western Sahara (+212)'
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE',
    flag: '🇾🇪',
    label: '🇾🇪 Yemen (+967)'
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
    flag: '🇿🇲',
    label: '🇿🇲 Zambia (+260)'
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
    flag: '🇿🇼',
    label: '🇿🇼 Zimbabwe (+263)'
  },
  {
    name: 'Åland Islands',
    dial_code: '+358',
    code: 'AX',
    flag: '🇦🇽',
    label: '🇦🇽 Åland Islands (+358)'
  }
];

// export const countryCodesMap = countryCodes.reduce((accumulate, countryCode) => {
//   accumulate[countryCode.code] = countryCode;
//   return accumulate;
// }, {});

export const countryCodes = [
  {
    code: '+1',
    countries: [
      { iso: 'US', name: 'United States', synonyms: ['USA', 'America'] },
      { iso: 'CA', name: 'Canada', synonyms: ['CAN'] },
      { iso: 'PR', name: 'Puerto Rico', synonyms: [] },
      { iso: 'DO', name: 'Dominican Republic', synonyms: ['Dominicana'] },
      { iso: 'BS', name: 'Bahamas', synonyms: [] },
      { iso: 'BB', name: 'Barbados', synonyms: [] },
      { iso: 'AG', name: 'Antigua and Barbuda', synonyms: [] },
      { iso: 'AI', name: 'Anguilla', synonyms: [] },
      { iso: 'VG', name: 'British Virgin Islands', synonyms: [] },
      { iso: 'VI', name: 'U.S. Virgin Islands', synonyms: [] },
      { iso: 'KY', name: 'Cayman Islands', synonyms: [] },
      { iso: 'BM', name: 'Bermuda', synonyms: [] },
      { iso: 'GD', name: 'Grenada', synonyms: [] },
      { iso: 'TC', name: 'Turks and Caicos Islands', synonyms: [] },
      { iso: 'MS', name: 'Montserrat', synonyms: [] },
      { iso: 'MP', name: 'Northern Mariana Islands', synonyms: [] },
      { iso: 'GU', name: 'Guam', synonyms: [] },
      { iso: 'AS', name: 'American Samoa', synonyms: [] },
      { iso: 'SX', name: 'Sint Maarten', synonyms: [] },
      { iso: 'LC', name: 'Saint Lucia', synonyms: [] },
      { iso: 'DM', name: 'Dominica', synonyms: [] },
      { iso: 'VC', name: 'Saint Vincent and the Grenadines', synonyms: [] },
      { iso: 'TT', name: 'Trinidad and Tobago', synonyms: [] },
      { iso: 'KN', name: 'Saint Kitts and Nevis', synonyms: [] },
      { iso: 'JM', name: 'Jamaica', synonyms: [] }
    ]
  },

  // All other countries (single entry per code)
  { code: '+7', countries: [{ iso: 'RU', name: 'Russia', synonyms: ['Russian Federation'] }] },
  { code: '+20', countries: [{ iso: 'EG', name: 'Egypt', synonyms: [] }] },
  { code: '+27', countries: [{ iso: 'ZA', name: 'South Africa', synonyms: [] }] },
  { code: '+30', countries: [{ iso: 'GR', name: 'Greece', synonyms: [] }] },
  { code: '+31', countries: [{ iso: 'NL', name: 'Netherlands', synonyms: [] }] },
  { code: '+32', countries: [{ iso: 'BE', name: 'Belgium', synonyms: [] }] },
  { code: '+33', countries: [{ iso: 'FR', name: 'France', synonyms: [] }] },
  { code: '+34', countries: [{ iso: 'ES', name: 'Spain', synonyms: [] }] },
  { code: '+36', countries: [{ iso: 'HU', name: 'Hungary', synonyms: [] }] },
  { code: '+39', countries: [{ iso: 'IT', name: 'Italy', synonyms: [] }] },
  { code: '+40', countries: [{ iso: 'RO', name: 'Romania', synonyms: [] }] },
  { code: '+41', countries: [{ iso: 'CH', name: 'Switzerland', synonyms: [] }] },
  { code: '+43', countries: [{ iso: 'AT', name: 'Austria', synonyms: [] }] },
  {
    code: '+44',
    countries: [
      { iso: 'GB', name: 'United Kingdom', synonyms: ['UK', 'Britain'] },
      { iso: 'GG', name: 'Guernsey', synonyms: [] },
      { iso: 'JE', name: 'Jersey', synonyms: [] },
      { iso: 'IM', name: 'Isle of Man', synonyms: [] }
    ]
  },
  { code: '+45', countries: [{ iso: 'DK', name: 'Denmark', synonyms: [] }] },
  // Continue with all other country codes...
  { code: '+46', countries: [{ iso: 'SE', name: 'Sweden', synonyms: [] }] },
  { code: '+47', countries: [{ iso: 'NO', name: 'Norway', synonyms: [] }] },
  { code: '+48', countries: [{ iso: 'PL', name: 'Poland', synonyms: [] }] },
  { code: '+49', countries: [{ iso: 'DE', name: 'Germany', synonyms: [] }] },
  { code: '+51', countries: [{ iso: 'PE', name: 'Peru', synonyms: [] }] },
  { code: '+52', countries: [{ iso: 'MX', name: 'Mexico', synonyms: [] }] },
  { code: '+53', countries: [{ iso: 'CU', name: 'Cuba', synonyms: [] }] },
  { code: '+54', countries: [{ iso: 'AR', name: 'Argentina', synonyms: [] }] },
  { code: '+55', countries: [{ iso: 'BR', name: 'Brazil', synonyms: [] }] },
  { code: '+56', countries: [{ iso: 'CL', name: 'Chile', synonyms: [] }] },
  { code: '+57', countries: [{ iso: 'CO', name: 'Colombia', synonyms: [] }] },
  { code: '+58', countries: [{ iso: 'VE', name: 'Venezuela', synonyms: [] }] },
  { code: '+60', countries: [{ iso: 'MY', name: 'Malaysia', synonyms: [] }] },
  { code: '+61', countries: [{ iso: 'AU', name: 'Australia', synonyms: [] }] },
  { code: '+62', countries: [{ iso: 'ID', name: 'Indonesia', synonyms: [] }] },
  { code: '+63', countries: [{ iso: 'PH', name: 'Philippines', synonyms: [] }] },
  { code: '+64', countries: [{ iso: 'NZ', name: 'New Zealand', synonyms: [] }] },
  { code: '+65', countries: [{ iso: 'SG', name: 'Singapore', synonyms: [] }] },
  { code: '+66', countries: [{ iso: 'TH', name: 'Thailand', synonyms: [] }] },
  { code: '+81', countries: [{ iso: 'JP', name: 'Japan', synonyms: [] }] },
  { code: '+82', countries: [{ iso: 'KR', name: 'South Korea', synonyms: [] }] },
  { code: '+84', countries: [{ iso: 'VN', name: 'Vietnam', synonyms: [] }] },
  { code: '+86', countries: [{ iso: 'CN', name: 'China', synonyms: [] }] },
  { code: '+90', countries: [{ iso: 'TR', name: 'Turkey', synonyms: [] }] },
  { code: '+91', countries: [{ iso: 'IN', name: 'India', synonyms: [] }] },
  { code: '+92', countries: [{ iso: 'PK', name: 'Pakistan', synonyms: [] }] },
  { code: '+93', countries: [{ iso: 'AF', name: 'Afghanistan', synonyms: [] }] },
  { code: '+94', countries: [{ iso: 'LK', name: 'Sri Lanka', synonyms: [] }] },
  { code: '+95', countries: [{ iso: 'MM', name: 'Myanmar', synonyms: [] }] },
  { code: '+98', countries: [{ iso: 'IR', name: 'Iran', synonyms: [] }] },
  // Africa continued
  { code: '+211', countries: [{ iso: 'SS', name: 'South Sudan', synonyms: [] }] },
  {
    code: '+212',
    countries: [
      { iso: 'MA', name: 'Morocco', synonyms: [] },
      { iso: 'EH', name: 'Western Sahara', synonyms: [] }
    ]
  },
  { code: '+213', countries: [{ iso: 'DZ', name: 'Algeria', synonyms: [] }] },
  { code: '+216', countries: [{ iso: 'TN', name: 'Tunisia', synonyms: [] }] },
  { code: '+218', countries: [{ iso: 'LY', name: 'Libya', synonyms: [] }] },
  { code: '+220', countries: [{ iso: 'GM', name: 'Gambia', synonyms: [] }] },
  { code: '+221', countries: [{ iso: 'SN', name: 'Senegal', synonyms: [] }] },
  { code: '+222', countries: [{ iso: 'MR', name: 'Mauritania', synonyms: [] }] },
  { code: '+223', countries: [{ iso: 'ML', name: 'Mali', synonyms: [] }] },
  { code: '+224', countries: [{ iso: 'GN', name: 'Guinea', synonyms: [] }] },
  { code: '+225', countries: [{ iso: 'CI', name: 'Ivory Coast', synonyms: ["Côte d'Ivoire"] }] },
  { code: '+226', countries: [{ iso: 'BF', name: 'Burkina Faso', synonyms: [] }] },
  { code: '+227', countries: [{ iso: 'NE', name: 'Niger', synonyms: [] }] },
  { code: '+228', countries: [{ iso: 'TG', name: 'Togo', synonyms: [] }] },
  { code: '+229', countries: [{ iso: 'BJ', name: 'Benin', synonyms: [] }] },
  { code: '+230', countries: [{ iso: 'MU', name: 'Mauritius', synonyms: [] }] },
  { code: '+231', countries: [{ iso: 'LR', name: 'Liberia', synonyms: [] }] },
  { code: '+232', countries: [{ iso: 'SL', name: 'Sierra Leone', synonyms: [] }] },
  { code: '+233', countries: [{ iso: 'GH', name: 'Ghana', synonyms: [] }] },
  { code: '+234', countries: [{ iso: 'NG', name: 'Nigeria', synonyms: [] }] },
  { code: '+235', countries: [{ iso: 'TD', name: 'Chad', synonyms: [] }] },
  { code: '+236', countries: [{ iso: 'CF', name: 'Central African Republic', synonyms: [] }] },
  { code: '+237', countries: [{ iso: 'CM', name: 'Cameroon', synonyms: [] }] },
  { code: '+238', countries: [{ iso: 'CV', name: 'Cape Verde', synonyms: [] }] },
  { code: '+239', countries: [{ iso: 'ST', name: 'São Tomé and Príncipe', synonyms: [] }] },
  { code: '+240', countries: [{ iso: 'GQ', name: 'Equatorial Guinea', synonyms: [] }] },
  { code: '+241', countries: [{ iso: 'GA', name: 'Gabon', synonyms: [] }] },
  { code: '+242', countries: [{ iso: 'CG', name: 'Republic of the Congo', synonyms: [] }] },
  {
    code: '+243',
    countries: [{ iso: 'CD', name: 'DR Congo', synonyms: ['Democratic Republic of the Congo'] }]
  },
  { code: '+244', countries: [{ iso: 'AO', name: 'Angola', synonyms: [] }] },
  { code: '+245', countries: [{ iso: 'GW', name: 'Guinea-Bissau', synonyms: [] }] },
  {
    code: '+246',
    countries: [{ iso: 'IO', name: 'British Indian Ocean Territory', synonyms: [] }]
  },
  { code: '+248', countries: [{ iso: 'SC', name: 'Seychelles', synonyms: [] }] },
  { code: '+249', countries: [{ iso: 'SD', name: 'Sudan', synonyms: [] }] },
  { code: '+250', countries: [{ iso: 'RW', name: 'Rwanda', synonyms: [] }] },
  { code: '+251', countries: [{ iso: 'ET', name: 'Ethiopia', synonyms: [] }] },
  { code: '+252', countries: [{ iso: 'SO', name: 'Somalia', synonyms: [] }] },
  { code: '+253', countries: [{ iso: 'DJ', name: 'Djibouti', synonyms: [] }] },
  { code: '+254', countries: [{ iso: 'KE', name: 'Kenya', synonyms: [] }] },
  { code: '+255', countries: [{ iso: 'TZ', name: 'Tanzania', synonyms: [] }] },
  { code: '+256', countries: [{ iso: 'UG', name: 'Uganda', synonyms: [] }] },
  { code: '+257', countries: [{ iso: 'BI', name: 'Burundi', synonyms: [] }] },
  { code: '+258', countries: [{ iso: 'MZ', name: 'Mozambique', synonyms: [] }] },
  { code: '+260', countries: [{ iso: 'ZM', name: 'Zambia', synonyms: [] }] },
  { code: '+261', countries: [{ iso: 'MG', name: 'Madagascar', synonyms: [] }] },
  {
    code: '+262',
    countries: [
      { iso: 'RE', name: 'Réunion', synonyms: [] },
      { iso: 'YT', name: 'Mayotte', synonyms: [] }
    ]
  },
  { code: '+263', countries: [{ iso: 'ZW', name: 'Zimbabwe', synonyms: [] }] },
  { code: '+264', countries: [{ iso: 'NA', name: 'Namibia', synonyms: [] }] },
  { code: '+265', countries: [{ iso: 'MW', name: 'Malawi', synonyms: [] }] },
  { code: '+266', countries: [{ iso: 'LS', name: 'Lesotho', synonyms: [] }] },
  { code: '+267', countries: [{ iso: 'BW', name: 'Botswana', synonyms: [] }] },
  { code: '+268', countries: [{ iso: 'SZ', name: 'Eswatini', synonyms: ['Swaziland'] }] },
  { code: '+269', countries: [{ iso: 'KM', name: 'Comoros', synonyms: [] }] },
  {
    code: '+290',
    countries: [
      { iso: 'SH', name: 'Saint Helena', synonyms: [] },
      { iso: 'TA', name: 'Tristan da Cunha', synonyms: [] }
    ]
  },
  { code: '+291', countries: [{ iso: 'ER', name: 'Eritrea', synonyms: [] }] },
  { code: '+297', countries: [{ iso: 'AW', name: 'Aruba', synonyms: [] }] },
  { code: '+298', countries: [{ iso: 'FO', name: 'Faroe Islands', synonyms: [] }] },
  { code: '+299', countries: [{ iso: 'GL', name: 'Greenland', synonyms: [] }] },

  // Europe continued
  { code: '+350', countries: [{ iso: 'GI', name: 'Gibraltar', synonyms: [] }] },
  { code: '+351', countries: [{ iso: 'PT', name: 'Portugal', synonyms: [] }] },
  { code: '+352', countries: [{ iso: 'LU', name: 'Luxembourg', synonyms: [] }] },
  { code: '+353', countries: [{ iso: 'IE', name: 'Ireland', synonyms: [] }] },
  { code: '+354', countries: [{ iso: 'IS', name: 'Iceland', synonyms: [] }] },
  { code: '+355', countries: [{ iso: 'AL', name: 'Albania', synonyms: [] }] },
  { code: '+356', countries: [{ iso: 'MT', name: 'Malta', synonyms: [] }] },
  { code: '+357', countries: [{ iso: 'CY', name: 'Cyprus', synonyms: [] }] },
  {
    code: '+358',
    countries: [
      { iso: 'FI', name: 'Finland', synonyms: [] },
      { iso: 'AX', name: 'Åland Islands', synonyms: [] }
    ]
  },
  { code: '+359', countries: [{ iso: 'BG', name: 'Bulgaria', synonyms: [] }] },
  { code: '+370', countries: [{ iso: 'LT', name: 'Lithuania', synonyms: [] }] },
  { code: '+371', countries: [{ iso: 'LV', name: 'Latvia', synonyms: [] }] },
  { code: '+372', countries: [{ iso: 'EE', name: 'Estonia', synonyms: [] }] },
  { code: '+373', countries: [{ iso: 'MD', name: 'Moldova', synonyms: [] }] },
  {
    code: '+374',
    countries: [
      { iso: 'AM', name: 'Armenia', synonyms: [] },
      { iso: 'QN', name: 'Nagorno-Karabakh', synonyms: [] }
    ]
  },
  { code: '+375', countries: [{ iso: 'BY', name: 'Belarus', synonyms: [] }] },
  { code: '+376', countries: [{ iso: 'AD', name: 'Andorra', synonyms: [] }] },
  { code: '+377', countries: [{ iso: 'MC', name: 'Monaco', synonyms: [] }] },
  { code: '+378', countries: [{ iso: 'SM', name: 'San Marino', synonyms: [] }] },
  { code: '+380', countries: [{ iso: 'UA', name: 'Ukraine', synonyms: [] }] },
  { code: '+381', countries: [{ iso: 'RS', name: 'Serbia', synonyms: [] }] },
  { code: '+382', countries: [{ iso: 'ME', name: 'Montenegro', synonyms: [] }] },
  { code: '+383', countries: [{ iso: 'XK', name: 'Kosovo', synonyms: [] }] },
  { code: '+385', countries: [{ iso: 'HR', name: 'Croatia', synonyms: [] }] },
  { code: '+386', countries: [{ iso: 'SI', name: 'Slovenia', synonyms: [] }] },
  { code: '+387', countries: [{ iso: 'BA', name: 'Bosnia and Herzegovina', synonyms: [] }] },
  { code: '+389', countries: [{ iso: 'MK', name: 'North Macedonia', synonyms: [] }] },
  { code: '+420', countries: [{ iso: 'CZ', name: 'Czech Republic', synonyms: [] }] },
  { code: '+421', countries: [{ iso: 'SK', name: 'Slovakia', synonyms: [] }] },
  { code: '+423', countries: [{ iso: 'LI', name: 'Liechtenstein', synonyms: [] }] },

  // Other regions
  {
    code: '+500',
    countries: [
      { iso: 'FK', name: 'Falkland Islands', synonyms: [] },
      { iso: 'GS', name: 'South Georgia', synonyms: [] }
    ]
  },
  { code: '+501', countries: [{ iso: 'BZ', name: 'Belize', synonyms: [] }] },
  { code: '+502', countries: [{ iso: 'GT', name: 'Guatemala', synonyms: [] }] },
  { code: '+503', countries: [{ iso: 'SV', name: 'El Salvador', synonyms: [] }] },
  { code: '+504', countries: [{ iso: 'HN', name: 'Honduras', synonyms: [] }] },
  { code: '+505', countries: [{ iso: 'NI', name: 'Nicaragua', synonyms: [] }] },
  { code: '+506', countries: [{ iso: 'CR', name: 'Costa Rica', synonyms: [] }] },
  { code: '+507', countries: [{ iso: 'PA', name: 'Panama', synonyms: [] }] },
  { code: '+508', countries: [{ iso: 'PM', name: 'Saint Pierre and Miquelon', synonyms: [] }] },
  { code: '+509', countries: [{ iso: 'HT', name: 'Haiti', synonyms: [] }] },
  {
    code: '+590',
    countries: [
      { iso: 'GP', name: 'Guadeloupe', synonyms: [] },
      { iso: 'BL', name: 'Saint Barthélemy', synonyms: [] },
      { iso: 'MF', name: 'Saint Martin', synonyms: [] }
    ]
  },
  { code: '+591', countries: [{ iso: 'BO', name: 'Bolivia', synonyms: [] }] },
  { code: '+592', countries: [{ iso: 'GY', name: 'Guyana', synonyms: [] }] },
  { code: '+593', countries: [{ iso: 'EC', name: 'Ecuador', synonyms: [] }] },
  { code: '+594', countries: [{ iso: 'GF', name: 'French Guiana', synonyms: [] }] },
  { code: '+595', countries: [{ iso: 'PY', name: 'Paraguay', synonyms: [] }] },
  { code: '+596', countries: [{ iso: 'MQ', name: 'Martinique', synonyms: [] }] },
  { code: '+597', countries: [{ iso: 'SR', name: 'Suriname', synonyms: [] }] },
  { code: '+598', countries: [{ iso: 'UY', name: 'Uruguay', synonyms: [] }] },
  {
    code: '+599',
    countries: [
      { iso: 'CW', name: 'Curaçao', synonyms: [] },
      { iso: 'BQ', name: 'Caribbean Netherlands', synonyms: [] }
    ]
  },
  { code: '+670', countries: [{ iso: 'TL', name: 'Timor-Leste', synonyms: [] }] },
  {
    code: '+672',
    countries: [
      { iso: 'NF', name: 'Norfolk Island', synonyms: [] },
      { iso: 'AQ', name: 'Antarctica', synonyms: [] }
    ]
  },
  { code: '+673', countries: [{ iso: 'BN', name: 'Brunei', synonyms: [] }] },
  { code: '+674', countries: [{ iso: 'NR', name: 'Nauru', synonyms: [] }] },
  { code: '+675', countries: [{ iso: 'PG', name: 'Papua New Guinea', synonyms: [] }] },
  { code: '+676', countries: [{ iso: 'TO', name: 'Tonga', synonyms: [] }] },
  { code: '+677', countries: [{ iso: 'SB', name: 'Solomon Islands', synonyms: [] }] },
  { code: '+678', countries: [{ iso: 'VU', name: 'Vanuatu', synonyms: [] }] },
  { code: '+679', countries: [{ iso: 'FJ', name: 'Fiji', synonyms: [] }] },
  { code: '+680', countries: [{ iso: 'PW', name: 'Palau', synonyms: [] }] },
  { code: '+681', countries: [{ iso: 'WF', name: 'Wallis and Futuna', synonyms: [] }] },
  { code: '+682', countries: [{ iso: 'CK', name: 'Cook Islands', synonyms: [] }] },
  { code: '+683', countries: [{ iso: 'NU', name: 'Niue', synonyms: [] }] },
  { code: '+685', countries: [{ iso: 'WS', name: 'Samoa', synonyms: [] }] },
  { code: '+686', countries: [{ iso: 'KI', name: 'Kiribati', synonyms: [] }] },
  { code: '+687', countries: [{ iso: 'NC', name: 'New Caledonia', synonyms: [] }] },
  { code: '+688', countries: [{ iso: 'TV', name: 'Tuvalu', synonyms: [] }] },
  { code: '+689', countries: [{ iso: 'PF', name: 'French Polynesia', synonyms: [] }] },
  { code: '+690', countries: [{ iso: 'TK', name: 'Tokelau', synonyms: [] }] },
  { code: '+691', countries: [{ iso: 'FM', name: 'Micronesia', synonyms: [] }] },
  { code: '+692', countries: [{ iso: 'MH', name: 'Marshall Islands', synonyms: [] }] },
  { code: '+850', countries: [{ iso: 'KP', name: 'North Korea', synonyms: [] }] },
  { code: '+852', countries: [{ iso: 'HK', name: 'Hong Kong', synonyms: [] }] },
  { code: '+853', countries: [{ iso: 'MO', name: 'Macau', synonyms: [] }] },
  { code: '+855', countries: [{ iso: 'KH', name: 'Cambodia', synonyms: [] }] },
  { code: '+856', countries: [{ iso: 'LA', name: 'Laos', synonyms: [] }] },
  { code: '+880', countries: [{ iso: 'BD', name: 'Bangladesh', synonyms: [] }] },
  { code: '+886', countries: [{ iso: 'TW', name: 'Taiwan', synonyms: [] }] },
  { code: '+960', countries: [{ iso: 'MV', name: 'Maldives', synonyms: [] }] },
  { code: '+961', countries: [{ iso: 'LB', name: 'Lebanon', synonyms: [] }] },
  { code: '+962', countries: [{ iso: 'JO', name: 'Jordan', synonyms: [] }] },
  { code: '+963', countries: [{ iso: 'SY', name: 'Syria', synonyms: [] }] },
  { code: '+964', countries: [{ iso: 'IQ', name: 'Iraq', synonyms: [] }] },
  { code: '+965', countries: [{ iso: 'KW', name: 'Kuwait', synonyms: [] }] },
  { code: '+966', countries: [{ iso: 'SA', name: 'Saudi Arabia', synonyms: [] }] },
  { code: '+966', countries: [{ iso: 'SA', name: 'Saudi Arabia', synonyms: [] }] },
  { code: '+967', countries: [{ iso: 'YE', name: 'Yemen', synonyms: [] }] },
  { code: '+968', countries: [{ iso: 'OM', name: 'Oman', synonyms: [] }] },
  { code: '+970', countries: [{ iso: 'PS', name: 'Palestine', synonyms: [] }] },
  { code: '+971', countries: [{ iso: 'AE', name: 'United Arab Emirates', synonyms: ['UAE'] }] },
  { code: '+972', countries: [{ iso: 'IL', name: 'Israel', synonyms: [] }] },
  { code: '+973', countries: [{ iso: 'BH', name: 'Bahrain', synonyms: [] }] },
  { code: '+974', countries: [{ iso: 'QA', name: 'Qatar', synonyms: [] }] },
  { code: '+975', countries: [{ iso: 'BT', name: 'Bhutan', synonyms: [] }] },
  { code: '+976', countries: [{ iso: 'MN', name: 'Mongolia', synonyms: [] }] },
  { code: '+977', countries: [{ iso: 'NP', name: 'Nepal', synonyms: [] }] },
  { code: '+992', countries: [{ iso: 'TJ', name: 'Tajikistan', synonyms: [] }] },
  { code: '+993', countries: [{ iso: 'TM', name: 'Turkmenistan', synonyms: [] }] },
  { code: '+994', countries: [{ iso: 'AZ', name: 'Azerbaijan', synonyms: [] }] },
  { code: '+995', countries: [{ iso: 'GE', name: 'Georgia', synonyms: [] }] },
  { code: '+996', countries: [{ iso: 'KG', name: 'Kyrgyzstan', synonyms: [] }] },
  { code: '+998', countries: [{ iso: 'UZ', name: 'Uzbekistan', synonyms: [] }] },

  // Caribbean and other territories
  // { code: '+1246', countries: [{ iso: 'BB', name: 'Barbados', synonyms: [] }] },
  // { code: '+1264', countries: [{ iso: 'AI', name: 'Anguilla', synonyms: [] }] },
  // { code: '+1268', countries: [{ iso: 'AG', name: 'Antigua and Barbuda', synonyms: [] }] },
  // { code: '+1284', countries: [{ iso: 'VG', name: 'British Virgin Islands', synonyms: [] }] },
  // { code: '+1340', countries: [{ iso: 'VI', name: 'U.S. Virgin Islands', synonyms: [] }] },
  // { code: '+1345', countries: [{ iso: 'KY', name: 'Cayman Islands', synonyms: [] }] },
  // { code: '+1441', countries: [{ iso: 'BM', name: 'Bermuda', synonyms: [] }] },
  // { code: '+1473', countries: [{ iso: 'GD', name: 'Grenada', synonyms: [] }] },
  // { code: '+1649', countries: [{ iso: 'TC', name: 'Turks and Caicos Islands', synonyms: [] }] },
  // { code: '+1664', countries: [{ iso: 'MS', name: 'Montserrat', synonyms: [] }] },
  // { code: '+1670', countries: [{ iso: 'MP', name: 'Northern Mariana Islands', synonyms: [] }] },
  // { code: '+1671', countries: [{ iso: 'GU', name: 'Guam', synonyms: [] }] },
  // { code: '+1684', countries: [{ iso: 'AS', name: 'American Samoa', synonyms: [] }] },
  // { code: '+1758', countries: [{ iso: 'LC', name: 'Saint Lucia', synonyms: [] }] },
  // { code: '+1767', countries: [{ iso: 'DM', name: 'Dominica', synonyms: [] }] },
  // {
  //   code: '+1784',
  //   countries: [{ iso: 'VC', name: 'Saint Vincent and the Grenadines', synonyms: [] }]
  // },
  // {
  //   code: '+1849',
  //   countries: [{ iso: 'DO', name: 'Dominican Republic', synonyms: ['Dominicana'] }]
  // },
  // { code: '+1868', countries: [{ iso: 'TT', name: 'Trinidad and Tobago', synonyms: [] }] },
  // { code: '+1869', countries: [{ iso: 'KN', name: 'Saint Kitts and Nevis', synonyms: [] }] },
  // { code: '+1876', countries: [{ iso: 'JM', name: 'Jamaica', synonyms: [] }] },
  // { code: '+1939', countries: [{ iso: 'PR', name: 'Puerto Rico', synonyms: [] }] },

  // Other special codes
  { code: '+211', countries: [{ iso: 'SS', name: 'South Sudan', synonyms: [] }] },
  { code: '+212', countries: [{ iso: 'MA', name: 'Morocco', synonyms: [] }] },
  { code: '+213', countries: [{ iso: 'DZ', name: 'Algeria', synonyms: [] }] },
  { code: '+216', countries: [{ iso: 'TN', name: 'Tunisia', synonyms: [] }] },
  { code: '+218', countries: [{ iso: 'LY', name: 'Libya', synonyms: [] }] },
  { code: '+220', countries: [{ iso: 'GM', name: 'Gambia', synonyms: [] }] },
  { code: '+221', countries: [{ iso: 'SN', name: 'Senegal', synonyms: [] }] },
  { code: '+222', countries: [{ iso: 'MR', name: 'Mauritania', synonyms: [] }] },
  { code: '+223', countries: [{ iso: 'ML', name: 'Mali', synonyms: [] }] },
  { code: '+224', countries: [{ iso: 'GN', name: 'Guinea', synonyms: [] }] },
  { code: '+225', countries: [{ iso: 'CI', name: 'Ivory Coast', synonyms: ["Côte d'Ivoire"] }] },
  { code: '+226', countries: [{ iso: 'BF', name: 'Burkina Faso', synonyms: [] }] },
  { code: '+227', countries: [{ iso: 'NE', name: 'Niger', synonyms: [] }] },
  { code: '+228', countries: [{ iso: 'TG', name: 'Togo', synonyms: [] }] },
  { code: '+229', countries: [{ iso: 'BJ', name: 'Benin', synonyms: [] }] },
  { code: '+230', countries: [{ iso: 'MU', name: 'Mauritius', synonyms: [] }] },
  { code: '+231', countries: [{ iso: 'LR', name: 'Liberia', synonyms: [] }] },
  { code: '+232', countries: [{ iso: 'SL', name: 'Sierra Leone', synonyms: [] }] },
  { code: '+233', countries: [{ iso: 'GH', name: 'Ghana', synonyms: [] }] },
  { code: '+234', countries: [{ iso: 'NG', name: 'Nigeria', synonyms: [] }] },
  { code: '+235', countries: [{ iso: 'TD', name: 'Chad', synonyms: [] }] },
  { code: '+236', countries: [{ iso: 'CF', name: 'Central African Republic', synonyms: [] }] },
  { code: '+237', countries: [{ iso: 'CM', name: 'Cameroon', synonyms: [] }] },
  { code: '+238', countries: [{ iso: 'CV', name: 'Cape Verde', synonyms: [] }] },
  { code: '+239', countries: [{ iso: 'ST', name: 'São Tomé and Príncipe', synonyms: [] }] },
  { code: '+240', countries: [{ iso: 'GQ', name: 'Equatorial Guinea', synonyms: [] }] },
  { code: '+241', countries: [{ iso: 'GA', name: 'Gabon', synonyms: [] }] },
  { code: '+242', countries: [{ iso: 'CG', name: 'Republic of the Congo', synonyms: [] }] },
  { code: '+243', countries: [{ iso: 'CD', name: 'DR Congo', synonyms: [] }] },
  { code: '+244', countries: [{ iso: 'AO', name: 'Angola', synonyms: [] }] },
  { code: '+245', countries: [{ iso: 'GW', name: 'Guinea-Bissau', synonyms: [] }] },
  {
    code: '+246',
    countries: [{ iso: 'IO', name: 'British Indian Ocean Territory', synonyms: [] }]
  },
  { code: '+248', countries: [{ iso: 'SC', name: 'Seychelles', synonyms: [] }] },
  { code: '+249', countries: [{ iso: 'SD', name: 'Sudan', synonyms: [] }] },
  { code: '+250', countries: [{ iso: 'RW', name: 'Rwanda', synonyms: [] }] },
  { code: '+251', countries: [{ iso: 'ET', name: 'Ethiopia', synonyms: [] }] },
  { code: '+252', countries: [{ iso: 'SO', name: 'Somalia', synonyms: [] }] },
  { code: '+253', countries: [{ iso: 'DJ', name: 'Djibouti', synonyms: [] }] },
  { code: '+254', countries: [{ iso: 'KE', name: 'Kenya', synonyms: [] }] },
  { code: '+255', countries: [{ iso: 'TZ', name: 'Tanzania', synonyms: [] }] },
  { code: '+256', countries: [{ iso: 'UG', name: 'Uganda', synonyms: [] }] },
  { code: '+257', countries: [{ iso: 'BI', name: 'Burundi', synonyms: [] }] },
  { code: '+258', countries: [{ iso: 'MZ', name: 'Mozambique', synonyms: [] }] },
  { code: '+260', countries: [{ iso: 'ZM', name: 'Zambia', synonyms: [] }] },
  { code: '+261', countries: [{ iso: 'MG', name: 'Madagascar', synonyms: [] }] }
];
